<template>
	<div class="detail-questions d-flex">
		<img 
			:src="validationImage" 
			:alt="validationName"
			class="detail-questions-image">
		<div class="wrapper-question">
			<div class="d-flex align-center">
				<div class="question-name">{{validationName}}</div>
				<img
					v-if="validationNationality"
					:src="question.nationality" 
					:alt="question.nationality"
					class="question-nationality">
			</div>
			<div class="question">{{question.description}}</div>
		</div>
	</div>
</template>
<script>
function validationImage() {
	return this.question.additionalInformation ?
		this.question.additionalInformation.customerImage : null;
}

function validationName() {
	return this.question.additionalInformation ? this.question.additionalInformation.name : null;
}

function validationNationality() {
	return this.question.additionalInformation && this.question.additionalInformation.nationality;
}

export default {
	name: 'questions',
	computed: {
		validationImage,
		validationName,
		validationNationality,
	},
	props: {
		question: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
<style lang="scss" scoped>

	.detail-questions-image {
		height: 11.3rem;
		margin-right: 3.3rem;
		width: 11.3rem;
	}

	.question-name {
		color: color(defaultBlack);
		font-family: font(open-semibold);
		font-size: size(maxsmall);
		margin-right: 1rem;
	}

	.question {
		color: color(text-grey-bold);
		font-family: font(open-semibold);
		font-size: size(maxsmall);
		margin-top: 1rem;
	}

	.wrapper-question {
		border-bottom: 0.1rem solid color(backGrey);
		height: fit-content;
		padding-bottom: 3.2rem;
		width: calc(100% - 11.3rem);
	}

	.question-nationality {
		height: 1.3rem;
	}
	
	@media screen and (max-width: 1024px) {
		.detail-questions-image {
			height: 3.2rem;
			margin-right: 0.8rem;
			width: 3.2rem;
		}

		.question-name, .question {
			font-size: size(small);
		}

		.wrapper-question {
			width: calc(100% - 4rem);
		}

		.wrapper-question {
			border-bottom: none;
		}
	}
</style>





// WEBPACK FOOTER //
// questions.vue?6dd17b08